// extracted by mini-css-extract-plugin
export default {"LogoBar":"LogoBar_LogoBar__0ka7x","panel":"LogoBar_panel__ftyKo","logo":"LogoBar_logo__N0l0a"};